import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './Services/Contexts/AuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <AuthProvider>
  <BrowserRouter>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </BrowserRouter>
   </AuthProvider>
);

reportWebVitals();
